import { Redirect, Route, Switch } from "react-router-dom";
import PoolMonitoringProvider from "src/context/monitoring/poolMonitoringContext";
import CreditScore from "src/view/CreditScore";
import CreditScoreStrategy from "src/view/CreditScoreStrategy";
import MarketOverview from "src/view/OverviewAnalysis/MarketOverview";
import NumberOfTransactions from "src/view/OverviewAnalysis/NumberOfTransactions";
import OverviewAnalysis from "src/view/OverviewAnalysis/Overview";
import TokenDomination from "src/view/OverviewAnalysis/TokenDomination";
import TokenInterestRate from "src/view/OverviewAnalysis/TokenInterestRate";
import TokenUtilizationRate from "src/view/OverviewAnalysis/TokenUtilizationRate";
import TransactionVolume from "src/view/OverviewAnalysis/TransactionVolume";
import PoolMonitoring from "src/view/PoolMonitoring";
import Reputation from "src/view/Reputation";
import DetailTokenHealth from "src/view/TokenHealth/DetailTokenHealth";
import OverviewTokenHealth from "src/view/TokenHealth/OverviewTokenHealth";
import TransactionMonitoring from "src/view/TransactionMonitoring";
import NOURTransactionTypes from "src/view/UserAnalysis/NOURTransactionTypes";
import NOURTransactionVolume from "src/view/UserAnalysis/NOURTransactionVolume";
import UserAnalysis from "src/view/UserAnalysis/Overview";
import TopUsers from "src/view/UserAnalysis/TopUsers";
import UserActiveness from "src/view/UserAnalysis/UserActiveness";
import AssetOverview from "src/view/UserMonitoring/AssetOverview";
import LiquidationHistory from "src/view/UserMonitoring/LiquidationHistory";
import UserMonitoring from "src/view/UserMonitoring/Overview";
import TotalValueLocked from "src/view/UserMonitoring/TotalValueLocked";
import TransactionHistory from "src/view/UserMonitoring/TransactionHistory";
import YourPortfolio from "src/view/YourPortfolio";

const RouteConfig = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return <Component {...props} />;
    }}
  />
);

function SubRouteApp() {
  return (
    <Switch>
      <RouteConfig exact path="/credit-score/:holder" component={CreditScore} />
      <Redirect from="/credit-score" to="/credit-score/overall" />
      <RouteConfig exact path="/tokens-health" component={OverviewTokenHealth} />
      <RouteConfig exact path="/tokens-health/:tokenId" component={DetailTokenHealth} />
      <RouteConfig exact path="/portfolio" component={YourPortfolio} />
      <RouteConfig exact path="/reputation" component={Reputation} />
      <RouteConfig exact path="/credit-score-strategy" component={CreditScoreStrategy} />
      {/* userMonitoring */}
      <RouteConfig exact path="/user-monitoring/asset-overview/:pool" component={AssetOverview} />
      <RouteConfig
        exact
        path="/user-monitoring/health-factor-and-liquidation-history/:pool"
        component={LiquidationHistory}
      />
      <RouteConfig exact path="/user-monitoring/total-value-locked/:pool" component={TotalValueLocked} />
      <RouteConfig exact path="/user-monitoring/transaction-history/:pool" component={TransactionHistory} />
      <RouteConfig exact path="/user-monitoring/:pool" component={UserMonitoring} />
      <Redirect from="/user-monitoring" to="/user-monitoring/trava-bsc" />
      {/* useAnalysis */}
      <RouteConfig exact path="/user-analysis/user-activeness/:pool" component={UserActiveness} />
      <RouteConfig
        exact
        path="/user-analysis/number-of-users-regarding-transaction-types/:pool"
        component={NOURTransactionTypes}
      />
      <RouteConfig
        exact
        path="/user-analysis/number-of-users-regarding-transaction-volume/:pool"
        component={NOURTransactionVolume}
      />
      <RouteConfig exact path="/user-analysis/top-users-by-transaction-volume/:pool" component={TopUsers} />
      <RouteConfig exact path="/user-analysis/:pool" component={UserAnalysis} />
      <Redirect from="/user-analysis" to="/user-analysis/trava-bsc" />
      {/* overview */}
      <RouteConfig exact path="/overview-analysis/market-overview/:pool" component={MarketOverview} />
      <RouteConfig exact path="/overview-analysis/token-domination/:pool" component={TokenDomination} />
      <RouteConfig exact path="/overview-analysis/token-utilization-rate/:pool" component={TokenUtilizationRate} />
      <RouteConfig exact path="/overview-analysis/token-interest-rate/:pool" component={TokenInterestRate} />
      <RouteConfig exact path="/overview-analysis/number-of-transactions/:pool" component={NumberOfTransactions} />
      <RouteConfig exact path="/overview-analysis/transaction-volume/:pool" component={TransactionVolume} />
      <RouteConfig exact path="/overview-analysis/:pool" component={OverviewAnalysis} />
      <Redirect from="/overview-analysis" to="/overview-analysis/trava-bsc" />
      {/* transaction monitoring */}
      <RouteConfig exact path="/transaction-monitoring/:pool" component={TransactionMonitoring} />
      <Redirect from="/transaction-monitoring" to="/transaction-monitoring/trava-bsc" />
      {/* pool monitoring */}
      <RouteConfig path="/pool-monitoring/:pool" component={PoolMonitoring} />
      <RouteConfig path="/pool-monitoring" component={PoolMonitoring} />

      <Redirect from="/" to="/credit-score/overall" />
    </Switch>
  );
}

export default function RouteApp() {
  return (
    <PoolMonitoringProvider>
      <SubRouteApp />
    </PoolMonitoringProvider>
  );
}
